import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { snakeCase } from 'lodash';
import SalesMixin from './SalesPageMixin';
let PlansMixin = class PlansMixin extends Mixins(SalesMixin) {
    get planTypes() {
        return ['Free', 'Starter', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Mythical'];
    }
    get proButtons() {
        return ['Go Starter', 'Go Bronze', 'Go Silver', 'Go Gold'];
    }
    get exclusivesHeaders() {
        return [
            'Sales Channel',
            'Monthly Subscription Fee',
            'Monthly Users',
            'Custom Branded Emailer',
            'Product Limits',
            'Convenience Fee Per Transaction',
            'Merchant Technical Support',
            'Support Channels',
            'Access to Payment Options',
            'Data Analytics Report and Dedicated Account Management Support',
            'In-App Store Customization',
        ];
    }
    get exclusivesContents() {
        return [
            {
                free: 'Facebook Messenger Only',
                starter: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya',
                bronze: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya, TikTok',
                silver: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya, TikTok',
                gold: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya, TikTok',
                platinum: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya, TikTok',
                diamond: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya, TikTok',
                mythical: 'Facebook Messenger, Instagram, Viber, GCash, Paymaya, TikTok',
            },
            {
                free: 'Free',
                starter: '₱1,000',
                bronze: '₱2,000',
                silver: '₱10,000',
                gold: '₱20,000',
                platinum: 'Custom Pricing',
                diamond: 'Custom Pricing',
                mythical: 'Custom Pricing',
            },
            {
                free: '',
                starter: '1-999',
                bronze: '1,000-9,999',
                silver: '10,000-49,999',
                gold: '50,000-99,999',
                platinum: '100,000-499,999',
                diamond: '500,000-999,999',
                mythical: '1,000,000-9,999,999',
            },
            {
                free: 'None',
                starter: 'None',
                bronze: 'None',
                silver: 'None',
                gold: 'Yes',
                platinum: 'Yes',
                diamond: 'Yes',
                mythical: 'Yes',
            },
            {
                free: 'Upload up to 100 Products',
                starter: 'Upload up to 1,000 Products',
                bronze: 'Upload up to 1,000 Products',
                silver: 'Upload up to 1,000 Products',
                gold: 'Upload up to 2,000 Products',
                platinum: 'Upload up to 5,000 Products',
                diamond: 'Upload up to 10,000 Products',
                mythical: 'unlimited',
            },
            {
                free: '₱10',
                starter: '₱10',
                bronze: '₱10',
                silver: '₱10',
                gold: '₱10',
                platinum: '0',
                diamond: '0',
                mythical: '0',
            },
            {
                free: 'Weekdays Support (Except Holidays). Response Time: Within 24 hours.',
                starter: 'Weekdays Support (Except Holidays). Response Time: Within 8 hours.',
                bronze: 'Weekdays Support (Except Holidays). Response Time: Within 8 hours.',
                silver: 'Weekdays Support (Except Holidays). Response Time: Within 8 hours.',
                gold: 'Weekdays and Saturday Support (Except Holidays). Response Time: Within 8 hours.',
                platinum: '24/7 Support (Except Holidays). Response Time: Within 2 hours.',
                diamond: '24/7 Support (Except Holidays). Response Time: Within 2 hours.',
                mythical: '24/7 Support (Except Holidays). Response Time: Within 2 hours.',
            },
            {
                free: 'Email, Messenger',
                starter: 'Email, Messenger',
                bronze: 'Email, Messenger',
                silver: 'Email, Messenger',
                gold: 'Email, Messenger',
                platinum: 'Email, Messenger, Account Manager',
                diamond: 'Email, Messenger, Account Manager',
                mythical: 'Email, Messenger, Account Manager',
            },
            {
                free: '',
                starter: 'Free access to BPI, GCash Payment Options',
                bronze: 'Free access to BPI, GCash Payment Options',
                silver: `Free access to BPI, GCash, PayMaya, PayMongo and 
                 Magpie (Subject to MID Availability) Payment Options.`,
                gold: `Free access to BPI, GCash, PayMaya, PayMongo and 
               Magpie (Subject to MID Availability) Payment Options and lower rates.`,
                platinum: `Free access to BPI, GCash, PayMaya, PayMongo and Magpie
                  (Subject to MID Availability)`,
                diamond: `Free access to BPI, GCash, PayMaya, PayMongo and Magpie 
                   (Subject to MID Availability) Payment Options and lower rates.`,
                mythical: `Free access to BPI, GCash, PayMaya, PayMongo and Magpie 
                   (Subject to MID Availability) Payment Options and lower rates.`,
            },
            {
                free: 'None',
                starter: 'None',
                bronze: 'None',
                silver: 'None',
                gold: 'None',
                platinum: 'Yes',
                diamond: 'Yes',
                mythical: 'Yes',
            },
            {
                free: 'Subject to Custom Pricing',
                starter: 'Subject to Custom Pricing',
                bronze: 'Subject to Custom Pricing',
                silver: 'Subject to Custom Pricing',
                gold: 'Subject to Custom Pricing',
                platinum: 'Subject to Custom Pricing',
                diamond: 'Subject to Custom Pricing',
                mythical: 'Subject to Custom Pricing',
            },
        ];
    }
    initializeProSubscription(plan, code) {
        const { origin } = window.location;
        if (code) {
            this.goToSignIn(`${origin}/login/client${this.setRefLink(plan)}&affiliate_code=${code}`);
        }
        else {
            this.goToSignIn(`${origin}/login/client${this.setRefLink(plan)}`);
        }
    }
    setRefLink(plan) {
        const tierPlan = snakeCase(plan.replace('Go ', 'Pro '));
        return `?plan_type=${tierPlan}`;
    }
};
PlansMixin = __decorate([
    Component
], PlansMixin);
export default PlansMixin;
